<template>
  <a-modal :title="title" :visible="visible" @ok="onOk" @cancel="onCancel">
    <a-form :form="form">
      <a-form-item label="城市名称" v-bind="layout">
        <a-input v-decorator="['city', { rules: [{ required: true, message: '必填' }] }]" />
      </a-form-item>
      <a-form-item label="所属国家" v-bind="layout">
        <a-select
          :disabled="!!id"
          v-decorator="['country', { rules: [{ required: true, message: '必填' }] }]"
          :options="countries"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import * as apis from '@/apis';

export default {
  props: {
    id: Number,
    visible: Boolean,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      layout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
      },
      countries: [],
    };
  },
  computed: {
    title() {
      return this.id ? '编辑城市' : '新增城市';
    },
  },
  watch: {
    async visible() {
      if (this.visible) {
        this.form.resetFields();

        const result1 = await apis.getCountries({ offset: 0, limit: 99 });
        this.countries = result1.data.map(country => ({ key: country.id, label: country.name }));

        if (this.id) {
          const result2 = await apis.getCity(this.id);

          this.form.setFieldsValue({
            city: result2.data.city,
            country: result2.data.country,
          });
        }
      }
    },
  },
  methods: {
    onOk() {
      this.form.validateFields(async (error, values) => {
        if (error) return;

        const data = { ...values };

        await (this.id ? apis.updateCity(data, this.id) : apis.createCity(data));
        this.$message.success('保存成功');
        this.$emit('confirm');
      });
    },
    onCancel() {
      this.$emit('cancel');
    },
  },
};
</script>
